import Vue from 'vue';
import {carTypeFilter} from './car-type.filter';
import { formatDateFilter, formatDateTimeFilter } from './format-date.filter'
import {currencyFilter} from './currency.filter';
import {initialFilter} from './initial.filter';
import {optionType} from './optionType.filter'

// register filters
Vue.filter('carType', carTypeFilter);
Vue.filter('formatDate', formatDateFilter);
Vue.filter('formatDateTime', formatDateTimeFilter);
Vue.filter('currency', currencyFilter);
Vue.filter('initial', initialFilter);
Vue.filter('optionType', optionType);
